import { createContext, useReducer } from 'react'

export const SettingsContext = createContext()

export const settingsReducer = (state, action) => {
    switch (action.type) {
        case 'UPDATE_SETTINGS':
            return {
                ...state,
                showextendedcompstructure: action.payload.showextendedcompstructure,
                useAdditionalEmplInfo: action.payload.useAdditionalEmplInfo,
                d365: action.payload.d365,
                isAlphaMega: action.payload.isAlphaMega,
                addApproverComments: action.payload.addApproverComments,
                mandatoryReplacement: action.payload.mandatoryReplacement,
                isEmployeeIDPascal: action.payload.isEmployeeIDPascal,
                allowMultipleTimeschemes: action.payload.allowMultipleTimeschemes,
                useReplacementApprover: action.payload.useReplacementApprover
            }
        case 'UPDATE_WINAUTH':
            return {
                ...state,
                isWinAuth: action.payload,

            }
        case 'UPDATE_EMPLOYEETABS':
            return {
                ...state,
                employmentTabData: action.payload.employmentTabData,
                miscellaneousTabData: action.payload.miscellaneousTabData,
                additionalTabData: action.payload.additionalTabData,
                personalTabData: action.payload.personalTabData
            }
        case 'UPDATE_TRAININGTABS':
            return {
                ...state,
                courseDetailsTabData: action.payload.courseDetailsTabData,
                participantsTabData: action.payload.participantsTabData
            }
        case 'RESET_STATE':
            return {
                showextendedcompstructure: undefined,
                useAdditionalEmplInfo: undefined,
                d365: undefined,
                isAlphaMega: undefined,
                useReplacementApprover: undefined,
                mandatoryReplacement: undefined,
                addApproverComments: undefined,
                employmentTabData: undefined,
                miscellaneousTabData: undefined,
                additionalTabData: undefined,
                personalTabData: undefined,
                allowMultipleTimeschemes: undefined
            }
        default:
            return state
    }
}



export const SettingsProvider = ({ children }) => {
    const [state, dispatch] = useReducer(settingsReducer, {
        showextendedcompstructure: undefined,
        useAdditionalEmplInfo: undefined,
        isEmployeeIDPascal: undefined,
        d365: undefined,
        useReplacementApprover: undefined,
        isAlphaMega: undefined,
        addApproverComments: undefined,
        mandatoryReplacement: undefined,
        employmentTabData: undefined,
        miscellaneousTabData: undefined,
        additionalTabData: undefined,
        personalTabData: undefined,
        isWinAuth: undefined,
        allowMultipleTimeschemes: undefined
    })

    return (
        <SettingsContext.Provider value={{ ...state, dispatch }}>
            {children}
        </SettingsContext.Provider>
    )
}